var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{class:_vm.$style.widgetsText},[_vm._v(" "+_vm._s(_vm.waitText)+" ")]),_c('BaseSpinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpinner),expression:"showSpinner"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }